import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto px-6 lg:px-10 xl:px-14 my-16 md:my-24 grid md:grid-cols-2 gap-10 md:gap-14" }
const _hoisted_2 = { class: "space-y-6 max-w-2xl" }
const _hoisted_3 = { class: "space-y-4 pt-2" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = { class: "flex items-center justify-center bg-white border-2 border-gray-300 rounded-full h-[40px] w-[40px]" }
const _hoisted_6 = { class: "flex items-center gap-3" }
const _hoisted_7 = { class: "flex items-center justify-center bg-white border-2 border-gray-300 rounded-full h-[40px] w-[40px]" }
const _hoisted_8 = { class: "flex items-center gap-3" }
const _hoisted_9 = { class: "flex items-center justify-center bg-white border-2 border-gray-300 rounded-full h-[40px] w-[40px]" }
const _hoisted_10 = { class: "w-full grid md:grid-cols-2" }
const _hoisted_11 = { class: "bg-theme-gray-1 px-6 md:px-16 py-16 md:py-24" }
const _hoisted_12 = { class: "max-w-xl space-y-6" }
const _hoisted_13 = { class: "space-y-4 pt-2" }
const _hoisted_14 = { class: "flex items-center gap-3" }
const _hoisted_15 = { class: "flex items-center justify-center bg-white border-2 border-gray-300 rounded-full h-[40px] w-[40px]" }
const _hoisted_16 = { class: "flex items-center gap-3" }
const _hoisted_17 = { class: "flex items-center justify-center bg-white border-2 border-gray-300 rounded-full h-[40px] w-[40px]" }
const _hoisted_18 = { class: "flex items-center gap-3" }
const _hoisted_19 = { class: "flex items-center justify-center bg-white border-2 border-gray-300 rounded-full h-[40px] w-[40px]" }
const _hoisted_20 = { class: "max-w-6xl mx-auto px-6 lg:px-10 xl:px-14 py-20 md:py-24" }
const _hoisted_21 = { class: "rounded-2xl bg-white/70 supports-[backdrop-filter]:backdrop-blur-md shadow-xl ring-1 ring-black/5 p-6 md:p-8 lg:p-10" }

import { computed, ref, watch } from 'vue'
import TopBanner from '@/components/TopBanner.vue'
import ContactForm from '@/components/ContactForm.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'AboutUs',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TopBanner, {
      layout: "normal",
      currentPage: "About Us",
      heading: "About Us",
      bannerClass: "banner-booking"
    }),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-theme-gray-5 text-size-8 md:text-head-md leading-tight md:leading-[1.15]" }, " For over 3 decades, we have been providing the best transport services. We offer Standard, Premium, and Luxury people carriers. ", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-theme-gray-4 font-light text-size-6" }, " We address our offer to all who want to travel in comfortable conditions. We have top-class vehicles, so our customers can be assured of comfort and safety. ", -1)),
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_font_awesome_icon, {
                size: "lg",
                icon: "fa-solid fa-check",
                class: "text-theme-active"
              })
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-theme-gray-4 font-light text-size-6" }, "Professionally Trained Chauffeurs", -1))
          ]),
          _createElementVNode("li", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_font_awesome_icon, {
                size: "lg",
                icon: "fa-solid fa-check",
                class: "text-theme-active"
              })
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-theme-gray-4 font-light text-size-6" }, "24/7 Full-Service Transportation", -1))
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_font_awesome_icon, {
                size: "lg",
                icon: "fa-solid fa-check",
                class: "text-theme-active"
              })
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-theme-gray-4 font-light text-size-6" }, "Global network of Transportation Partners", -1))
          ])
        ])
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "rounded-2xl overflow-hidden shadow-xl ring-1 ring-black/5" }, [
        _createElementVNode("img", {
          src: "/assets/13.jpeg",
          alt: "Vehitra World",
          class: "w-full h-full object-cover"
        })
      ], -1))
    ]),
    _createElementVNode("section", _hoisted_10, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "h-[240px] md:h-auto bg-center bg-cover banner-river" }, null, -1)),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "text-theme-gray-5 text-size-8 md:text-head-md leading-snug" }, " Our main headquarters is in the Kingdom of Bahrain with satellite office in Riyad, Saudia Arabia ", -1)),
          _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-theme-gray-4 font-light text-size-6" }, " Our broad network of transportation partners across the globe allows us to offer excellent ground transportation services for both individuals and groups of any size, wherever they may be. Whether you’re planning a special event with loved ones or friends, we understand that you would prefer to enjoy yourself and not be concerned about driving. Our skilled chauffeurs will navigate you through any city you find yourself in. ", -1)),
          _createElementVNode("ul", _hoisted_13, [
            _createElementVNode("li", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_font_awesome_icon, {
                  size: "lg",
                  icon: "fa-solid fa-check",
                  class: "text-theme-active"
                })
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-theme-gray-4 font-light text-size-6" }, "Professionally Trained Chauffeurs", -1))
            ]),
            _createElementVNode("li", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_font_awesome_icon, {
                  size: "lg",
                  icon: "fa-solid fa-check",
                  class: "text-theme-active"
                })
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-theme-gray-4 font-light text-size-6" }, "24/7 Full-Service Transportation", -1))
            ]),
            _createElementVNode("li", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_font_awesome_icon, {
                  size: "lg",
                  icon: "fa-solid fa-check",
                  class: "text-theme-active"
                })
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-theme-gray-4 font-light text-size-6" }, "Global network of Transportation Partners", -1))
            ])
          ])
        ])
      ])
    ]),
    _cache[13] || (_cache[13] = _createStaticVNode("<section class=\"max-w-7xl mx-auto px-6 lg:px-10 xl:px-14 mt-16 md:mt-24\" data-v-48f2e3e1><div class=\"grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8\" data-v-48f2e3e1><div class=\"card-surface from-slate-700 to-slate-600\" data-v-48f2e3e1><div class=\"card-number\" data-v-48f2e3e1>01</div><span class=\"font-icon theme-icon calendar-icon text-white text-[44px]\" data-v-48f2e3e1></span><p class=\"card-text\" data-v-48f2e3e1> Each of our drivers is characterized by professionalism and punctuality </p></div><div class=\"card-surface from-emerald-700 to-emerald-600\" data-v-48f2e3e1><div class=\"card-number\" data-v-48f2e3e1>02</div><span class=\"font-icon theme-icon arrow-rounded-icon text-white text-[44px]\" data-v-48f2e3e1></span><p class=\"card-text\" data-v-48f2e3e1> We always go extra mile when it comes to the safety </p></div><div class=\"card-surface from-slate-700 to-slate-600\" data-v-48f2e3e1><div class=\"card-number\" data-v-48f2e3e1>03</div><span class=\"font-icon theme-icon suitcase-icon text-white text-[44px]\" data-v-48f2e3e1></span><p class=\"card-text\" data-v-48f2e3e1> You can rely on our knowledge and experience to guide you on your tour </p></div><div class=\"card-surface from-emerald-700 to-emerald-600\" data-v-48f2e3e1><div class=\"card-number\" data-v-48f2e3e1>04</div><span class=\"font-icon theme-icon award-icon text-white text-[44px]\" data-v-48f2e3e1></span><p class=\"card-text\" data-v-48f2e3e1> Premium quality and award winning customer service </p></div></div></section>", 1)),
    _createElementVNode("section", _hoisted_20, [
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-center space-y-3 mb-10" }, [
        _createElementVNode("h2", { class: "text-theme-gray-4 text-size-7 md:text-head-md-2 font-light" }, [
          _createElementVNode("p", null, "Private chauffeur, sightseeing tour?"),
          _createElementVNode("p", null, "Please fill out the form below with questions or comments")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(ContactForm)
      ])
    ])
  ], 64))
}
}

})